"use strict"

import { Data } from '@/lib/core/components/data/data'

export class StatusLotes extends Data {
  constructor({ form, updateStore, Logic, component }) {
    super({ form, module: 'data', dataId: 'lotes_status', updateStore, Logic, component, originClass: StatusLotes })
  }
  async colors() {
    await this.#readStatusColors()
    return this.list
  }
  async #readStatusColors() { // eslint-disable-line
    await this
      .list
      .read({
        dataId: this.custom?.insertLotes?.statusDataId || 'lotes_status',
        project: { color: 1 }
        // add cache
      })
  }
}